<template>
  <div class="galeria">
    <div
      id="gale"
      class="carousel slide"
      data-ride="carousel"
      data-interval="false"
    >
      <div class="carousel-inner">
        <div
          v-for="(img, index) in images"
          :key="index"
          class="carousel-item"
          :class="index === 1 ? 'active' : ''"
        >
          <img :src="img.url" class="d-block w-100" alt="..." />
        </div>
      </div>
      <a
        class="carousel-control-prev"
        href="#gale"
        role="button"
        data-slide="prev"
      >
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a
        class="carousel-control-next"
        href="#gale"
        role="button"
        data-slide="next"
      >
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Galeria',
  data() {
    return {
      images: [
        { url: require('@/assets/images/galeria/galeria-01.jpg') },
        { url: require('@/assets/images/galeria/galeria-02.jpg') },
        { url: require('@/assets/images/galeria/galeria-03.jpg') },
        { url: require('@/assets/images/galeria/galeria-04.jpg') },
        { url: require('@/assets/images/galeria/galeria-05.jpg') },
        { url: require('@/assets/images/galeria/galeria-06.jpg') },
        { url: require('@/assets/images/galeria/galeria-07.jpg') },
        { url: require('@/assets/images/galeria/galeria-08.jpg') },
        { url: require('@/assets/images/galeria/galeria-09.jpg') },
        { url: require('@/assets/images/galeria/galeria-10.jpg') },
        { url: require('@/assets/images/galeria/galeria-11.jpg') },
        { url: require('@/assets/images/galeria/galeria-12.jpg') },
        { url: require('@/assets/images/galeria/galeria-13.jpg') },
        { url: require('@/assets/images/galeria/galeria-14.jpg') },
        { url: require('@/assets/images/galeria/galeria-15.jpg') },
        { url: require('@/assets/images/galeria/galeria-16.jpg') },
        { url: require('@/assets/images/galeria/galeria-17.jpg') },
        { url: require('@/assets/images/galeria/galeria-19.jpg') },
        { url: require('@/assets/images/galeria/galeria-20.jpg') },
      ],
    }
  },
}
</script>

<style lang="scss" scoped></style>
